import React, { Component } from 'react';

import BookInfo from './book-info';
import DownloadsColumm from './downloads-column';

class BookItem extends Component {
	render() {
		const book = this.props.book;
		return (
			<article className={ `two-col-content-panel book type-book post-${book.id}` }>
				<BookInfo bookLink={ book.link } bookTitle={ book.title.rendered } bookDescription={ book.excerpt.rendered } />
				<DownloadsColumm downloads={ book.free_downloads } bookLink={ book.link } />
			</article>
		);
	}
}

export default BookItem;